import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const useIsCurrentUserAML = () => {
  const userRole = useCurrentUserAccessRole();

  return userRole === AccessRoleCodes.Aml;
};
